module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1001-fe425ed71b505e726422db7af1615454.png";